import React from 'react';
import { connect } from 'react-redux';
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc'

import _ from 'lodash';

import { Flex , SVGButton, ToogleSwitch} from '/app/src/component';
import Jibber from '/app/src/jibber'
import { FAQModel, CustomizationModel } from '/app/src/model'
import { FAQSelector } from '/app/src/model/selectors'

import FAQAddNewQuestion from '../AddNewQuestion'
import FAQItem from '../ListItem';
import style from './style.css'

class DashboardFAQ extends Jibber{
    constructor(props) {
        super(props);

        let items =_.sortBy(props.items, ['order'])
        this.useState({
            searchInput: '',
            activeItem: null,
            dirty: {},
            isEdit: false,
            items: items
       })

        this._searchInputHandler = this._searchInputHandler.bind(this);
        this._renderSearchField = this._renderSearchField.bind(this)
        this._saveToDatabase = this._saveToDatabase.bind(this);
        this.onSortEnd = this.onSortEnd.bind(this)
        this._removeFromDatabase = this._removeFromDatabase.bind(this);

        this.__setSortedItems = this.__setSortedItems.bind(this);
    }

    componentDidMount() {
        this.props.readItems();
    }

    componentDidUpdate(prevProps, prevState){
        if(prevState.isEdit === true && this.state.isEdit === false){
            if (_.size(this.state.dirty)>0){
                this.setDirty({})
                this.props.readItems();
                this.__setSortedItems(this.props.items)
                return
            }
        }
        if(prevProps.items !== this.props.items){
            this.__setSortedItems(this.props.items)
        }
    }

    __setSortedItems(items){
        const sorted = _.sortBy(items, ['order'])
        this.setItems(sorted)
    }

    onSortEnd({oldIndex, newIndex}){
        let newSortedLists = arrayMove(this.state.items, oldIndex, newIndex)

        let dirty = this.state.dirty
        for(var index in newSortedLists){
            let item = newSortedLists[index]
            if(parseInt(item.order, 10) !== parseInt(index, 10)) {
                newSortedLists[index].order = index
                dirty[item.id] = true
            }
        }
        this.setItems(newSortedLists)
        this.setDirty(dirty)
    }

    _saveToDatabase(e, id, title, body) {
        e.stopPropagation();
        this.props.updateItem(id, { question: title, answer: body });
    }

    _removeFromDatabase(e, id) {
        e.stopPropagation();
        this.props.removeItem(id);
    }

    _searchInputHandler(event) {
        this.setState({ searchInput: event.target.value });
    }

    _renderSearchField(){

        let {items} = this.state;

        let EditButton;
        //if no such item, then edit button is disable
        if(items.length <= 0){
            EditButton = (
                <SVGButton
                    borderRadius='30px'
                    paddingLeft='20px'
                    paddingRight='10px'
                    mx='20px'
                    height='49px'
                    cursor='default'
                    border
                    src='/images/ChangeOrder_M.svg'
                    text='Ändra ordning'
                    fontSize='21px'
                    color='lightgrey'
                />
            )
        } else {
            EditButton = (
                <SVGButton
                    color='black'
                    hover='blue'
                    borderRadius='30px'
                    paddingLeft='20px'
                    paddingRight='10px'
                    mx='20px'
                    height='49px'
                    border
                    fontSize='21px'
                    src='/images/Edit_M.svg'
                    text='Ändra ordning'
                    onClick={()=>this.setIsEdit(true)}
                />
            )
        }

        const SaveButtons = (
            <React.Fragment>
                <SVGButton
                    color='black'
                    hover='blue'
                    borderRadius='30px'
                    paddingLeft='20px'
                    paddingRight='10px'
                    ml='20px'
                    height='49px'
                    border
                    fontSize='21px'
                    text='Avbryt'
                    src='/images/Return.svg'
                    onClick={()=>this.setIsEdit(false)} />
                <SVGButton
                    color='black'
                    hover='blue'
                    borderRadius='30px'
                    paddingLeft='20px'
                    paddingRight='10px'
                    mx='20px'
                    height='49px'
                    fontSize='21px'
                    border
                    text='Spara'
                    src='/images/Save.svg'
                    onClick={()=>{
                        var payload = []
                        _.forEach(this.state.dirty, (value, itemId) => {
                            const item = _.find(this.state.items, (c)=>{
                                return c.id === parseInt(itemId, 10)
                            })
                            if(item){
                                payload.push({
                                    'id': item.id,
                                    'updates': {
                                        'order': item.order
                                    }
                                })
                            }
                        })
                        this.props.updateItems(payload)
                        this.setIsEdit(false)
                    }}/>
                </React.Fragment>)

        const SearchField = (
            <Flex width='100%'
                className={style.FAQSearch}
                basis='140px'
                center
                wrap
                px='30px'>
                <Flex
                    w='100%'
                    center>
                    <ToogleSwitch on={this.props.faqActive} manual
                        onChange={(e)=>{
                            this.props.setFaqActive(!this.props.faqActive)}}/>
                        <Flex mr='auto' color='black' fontSize='18px' fontWeight='500' ml='20px'>
                            Aktivera Frågor <Flex color='darkgrey' ml='10px'> (live)</Flex>
                        </Flex>
                    {!this.state.isEdit && EditButton}
                    {this.state.isEdit && SaveButtons}
                </Flex>
                <Flex w='100%' h='40px' px='20px' py='3px' center>
                    <input
                        onChange={this._searchInputHandler}
                        value={this.searchInput}
                        placeholder="Sök bland frågorna..."
                        className={style.FAQSearchInput} />
                </Flex>
            </Flex>)

        return SearchField
    }

    _renderFAQList(){
        const disabled = !this.state.isEdit
        const SortableItem = SortableElement(({item}) => {
            return (
                <li className={style.FAQListItem}>
                    <FAQItem
                        title={item.question} body={item.answer}
                        id={item.id} key={item.id}
                        item={item}
                        _onClick={()=>{
                            if(item.id !== this.state.activeItem){
                                this.setActiveItem(item.id)
                            }
                        }}
                        updateItem={this.props.updateItem}
                        currentItem={this.state.activeItem}
                        searchInput={this.state.searchInput}
                        isEdit={this.state.isEdit}
                        saveToDatabase={this._saveToDatabase}
                        removeFromDatabase={this._removeFromDatabase} />
                </li>)})

        const SortableList = SortableContainer(({items}) => {
            return (
                <ul className={style.FAQList}>
                  {items.map((item, index) => {
                       return  <SortableItem index={index} key={`item-${item.id}`} item={item} disabled={disabled}/>
                  })}
                </ul>)})

        return <SortableList items={this.state.items} onSortEnd={this.onSortEnd} axis='xy' distance={5}/>
    }

    render() {
        const {items} = this.props
        const AddNewFaqButton = (
            <FAQAddNewQuestion
                currentItem={this.state.activeItem}
                _onClick={()=>{this.setActiveItem(0)}}
                nbrFAQ={Object.keys(items).length}/>
        )
        return (
            <Flex column grow>
                {this._renderSearchField()}

                <Flex column className={style.FAQItemList} overflow='auto' grow>
                    <div style={{
                        'flexGrow': 1,
                        'padding': '0px 20px'
                    }}>
                        {AddNewFaqButton}
                        {this._renderFAQList()}
                    </div>
                </Flex>
            </Flex>
        );
    }
}

const { selector: itemsNetworkSelector, dispatcher: readItems } = FAQModel.readItemsRequest()
const {dispatcher: itemUpdate } = FAQModel.updateItemRequest()
const {dispatcher: itemsUpdate} = FAQModel.updateItemsRequest()
const {dispatcher: removeItemDispatch} = FAQModel.removeItemRequest();
const {dispatcher: updateCustomizationDispatch} = CustomizationModel.updateRequest()

const mapDispatchToProps = (dispatch, props) => {
    return {
        'readItems': () => { dispatch(readItems()) },
        'updateItem': (itemId, updates) => { dispatch(itemUpdate(itemId, updates)) },
        'updateItems': (items)=>{dispatch(itemsUpdate(items))},
        removeItem: (faqId) =>  dispatch(removeItemDispatch(faqId)),
        setFaqActive: (isActive) => dispatch(updateCustomizationDispatch({faq_on:isActive}))

    }
}
function mapStateToProps(state, props) {
    let network = itemsNetworkSelector(state)['network']
    const faqActive = CustomizationModel.selector.getFaqActive(state)
    let items = FAQSelector.getFAQs(state).toJS()
    return { network, items, faqActive}
}
export default connect(mapStateToProps, mapDispatchToProps)(DashboardFAQ)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Normal/List/index.js